import React from 'react';

import { ModifiedDateMetadata, OwnerMetadata } from '~src/spacesPlatform/components/header/HeaderMetadataRow';
import { ActionsMenuIcon, FavoriteToggleWithCountsIcon } from '~src/spacesPlatform/components/header/HeaderNameRowIcons';
import { ConnectedSpaceHeader } from '~src/spacesPlatform/components/header/SpaceHeader';

import { SiteUrlsProps } from '../../../bootstrap/redux/selectors/SiteUrlsSelectors';
import { ISpaceItemDetailInfo } from '../../../spacesPlatform/models/ISpaceItemDetailInfo';
import { FieldConceptIndexingErrorCode, FieldConceptIndexingStatusCode } from '../../serverApi/requests/GetFieldConceptIndexingStatus';
import { IDataRoleActions } from '../../serverApi/types/IDataRoleActions';
import { DataRoleStatusMetadata } from './DataRoleStatusMetadata';

export interface DataRoleSpaceHeaderProps extends SiteUrlsProps {
  readonly item: ISpaceItemDetailInfo<'dataRole'>;
  readonly availableActions: IDataRoleActions;
  readonly addToFavorites: () => void;
  readonly removeFromFavorites: () => void;
  readonly fieldConceptIndexingStatusCode: FieldConceptIndexingStatusCode;
  readonly fieldConceptIndexingErrorCode: FieldConceptIndexingErrorCode;
}

export function DataRoleSpaceHeader(props: DataRoleSpaceHeaderProps): JSX.Element {
  return <ConnectedSpaceHeader
      item={props.item}
      nameRowIcons={
        <>
          { FavoriteToggleWithCountsIcon({
            item: props.item,
            addToFavorites: props.addToFavorites,
            removeFromFavorites: props.removeFromFavorites,
          }) }
          {ActionsMenuIcon(props.item)}
        </> }
      availableActions={props.availableActions}
      metadataRow={
        <React.Fragment>
          { OwnerMetadata(props.item.owner, props.urls) }
          { ModifiedDateMetadata(props.item.updatedAt) }
          { DataRoleStatusMetadata(props.fieldConceptIndexingStatusCode, props.fieldConceptIndexingErrorCode) }
        </React.Fragment>
      }
  />;
}
